import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=0589b905&scoped=true"
import script from "./EmailVerified.vue?vue&type=script&lang=js"
export * from "./EmailVerified.vue?vue&type=script&lang=js"
import style0 from "./EmailVerified.vue?vue&type=style&index=0&id=0589b905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589b905",
  null
  
)

export default component.exports